import { DateTime } from 'luxon';
import { AppThunk } from '../../../store/rootReducer';
import { episodeMeasurementMetricSelector } from '../../episodeMeasurement/selectors/episode-measurement.selectors';
import { STOP_MEASURE_EPISODE_DURATION } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';
import { getRulerTimeStarted } from '../selectors/analytics-info.selectors';

export const trackStopEpisodeMeasurement =
  (interaction: 'escape' | 'click', analyticsEventTrack = track): AppThunk =>
  (_, getState) => {
    const episodeMeasurementInfo = episodeMeasurementMetricSelector(getState());
    const timeStarted = getRulerTimeStarted(getState());
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: STOP_MEASURE_EPISODE_DURATION,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        plot: 'hr',
        value: episodeMeasurementInfo ?? '0ms',
        interaction,
        time_spent_ms: DateTime.now().toMillis() - timeStarted,
      },
    });
  };
